import { render, staticRenderFns } from "./add.vue?vue&type=template&id=41f4d600&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=41f4d600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4d600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f4d600')) {
      api.createRecord('41f4d600', component.options)
    } else {
      api.reload('41f4d600', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=41f4d600&scoped=true&", function () {
      api.rerender('41f4d600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/recyclingProps/components/add.vue"
export default component.exports